export interface CreateInternalLinkArgs {
  linkId: string;
  links: { [x: string]: { slug: string } };
}

export function createInternalLink({ linkId, links }: CreateInternalLinkArgs) {
  let link = links?.[linkId]?.slug;

  if (!link || link === "home") {
    link = "/";
  } else {
    link = `/${link}`;
  }

  return link;
}
